import { Flex } from 'components/Box'
import React from 'react'
import { EmailVerificationWrapper, EmailVerificationBody } from '../FormsStyled'
import { ReactComponent as GmailMessage } from 'assets/Icons/GmailMessage.svg';
import { Text } from 'components/Text';
import { ReactComponent as VerificationButton } from 'assets/Buttons/VerificationButton.svg';
import { NavLink } from 'components/Header/HeaderStyled';

const ConfirmEmail: React.FC = () => {

    return (
        <>
            <EmailVerificationBody>
                <EmailVerificationWrapper>
                    <Flex>

                        <GmailMessage />
                        <Text>Confirm your email address</Text>
                        <h5>Thanks for joining The Platform!</h5>
                        <p>Your emailed has been verified successfully.</p>

                        <NavLink to='/home'>
                            <VerificationButton />
                        </NavLink>

                    </Flex>
                </EmailVerificationWrapper>
            </EmailVerificationBody>
        </>
    )
}

export default ConfirmEmail